export const NAME = 'streaks';

export const INDEXED_WEEKDAYS = ['Su', 'M', 'Tu', 'W', 'Th', 'F', 'Sa'] as const;
export const MINIMUM_WEEKDAYS_TO_SHOW = 5 as const;
